<template>
  <div>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <v-flex
      v-if="isLoading"
      justify-center
    >
      <u-loader />
    </v-flex>
    <div v-else>
      <v-card class="card-body">
        <v-container>
          <h5>Bezeichnung</h5>
          <v-text-field
            v-model="holidayNameDE.description"
            label="Deutsch"
          />
          <v-text-field
            v-model="holidayNameFR.description"
            label="Französisch"
          />
          <v-text-field
            v-model="holidayNameIT.description"
            label="Italienisch"
          />
        </v-container>
      </v-card>
      <v-card class="card-body mt-4">
        <v-container>
          <h5>Allgemeine Informationen</h5>
          <u-date-picker
            v-model="date"
            label="Datum"
          />
          <v-select
            v-model="holidayType"
            :items="publicHolidayTypes"
            class="mt-4"
            item-text="text"
            item-value="value"
            label="Feiertagstyp"
          />
        </v-container>
      </v-card>

      <v-card class="card-body mt-4">
        <v-container>
          <h5>Gültigkeitsbereich</h5>
          <u-tree-view
            v-model="selectedLocations"
            :tree-view-items="localisedOptions"
            class="mt-2"
            item-key="path"
            item-children="children"
            :display-feiertags-region-import="true"
          />
        </v-container>
      </v-card>
      <hr class="custom_hr">
      <div class="mt-4">
        <v-btn
          :disabled="
            !selectedLocations.length ||
              !holidayType ||
              !date ||
              !holidayNameDE.description ||
              !holidayNameFR.description ||
              !holidayNameIT.description
          "
          class="btn-left"
          color="success"
          raised
          @click="saveResourceCalendar"
        >
          <i class="fas fa-save mr-3" /> Speichern
        </v-btn>

        <v-btn
          color="#e72b37"
          raised
          style="color: white"
          @click="cancel"
        >
          <i class="fas fa-ban mr-3" /> Abbrechen
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import UDatePicker from "@/components/common/UDatePicker.vue";
import UTreeView from "@/components/common/UTreeView.vue";
import {
  GetFullLocationTree,
  GetRessourceCalendar,
  UpdateRessourceCalendar,
} from "@/services/minimum.wage.services/resourceCalendar.minimum.wage";
import moment from "moment";
import {
  CreateTreeViewObject,
  ValidateTreeView,
  GetOptionIdsForOptionPaths,
} from "@/helpers/TreeViewHelperResourceCalendar";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

export default {
  components: {
    UDatePicker,
    UTreeView,
  },
  mixins: [MinimumWageMixin],
  props: {
    resourceCalendarToEdit: {
      type: Object,
      required: false,
      default: () => null,
    },
    publicHolidayTypes: {
      type: Array,
      default: () => [],
    },
    localisedOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      holidayNameDE: { id: 0, description: "", language: "de-CH" },
      holidayNameFR: { id: 0, description: "", language: "fr-CH" },
      holidayNameIT: { id: 0, description: "", language: "it-CH" },
      date: null,
      holidayType: 1,
      validForCH: false,
      selectedLocations: [],
      locationTree: [],
      locationOptions: [],
      fullLocationTree: null,
      isLoading: false,
      errorObject: null,
    };
  },
  watch: {
    resourceCalendarToEdit(newVal) {
      this.date = moment(newVal.date).format("YYYY-MM-DD");
      this.holidayType = newVal.publicHolidayType;
      this.getCurrentRessourceCalendar();
    },
  },
  created() {
    if (this.resourceCalendarToEdit) {
      this.getCurrentRessourceCalendar();
    }
  },
  methods: {
    getCurrentRessourceCalendar() {
      this.isLoading = true;
      GetRessourceCalendar(
        this.resourceCalendarToEdit.id,
        (response) => {
          if (response) {
            if (response.date) {
              this.date = moment(response.date).format("YYYY-MM-DD");
            }
            if (response.publicHolidayType) {
              this.holidayType = response.publicHolidayType;
            }
            if (response.ressourceCalendarContents.length) {
              response.ressourceCalendarContents.forEach(
                (ressourceCalendarContent) => {
                  switch (ressourceCalendarContent.language) {
                    case "de-CH":
                      this.holidayNameDE.description =
                        ressourceCalendarContent.holidayDescription;
                      this.holidayNameDE.id = ressourceCalendarContent.id;
                      break;
                    case "fr-CH":
                      this.holidayNameFR.description =
                        ressourceCalendarContent.holidayDescription;
                      this.holidayNameFR.id = ressourceCalendarContent.id;
                      break;
                    case "it-CH":
                      this.holidayNameIT.description =
                        ressourceCalendarContent.holidayDescription;
                      this.holidayNameIT.id = ressourceCalendarContent.id;
                      break;
                  }
                },
              );
            }
          }
          this.GetAllLocationOptions();
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    GetAllLocationOptions() {
      this.isLoading = true;
      GetFullLocationTree(
        this.resourceCalendarToEdit.id,
        (response) => {
          const validatedTreeView = ValidateTreeView(response);
          this.locationOptions = validatedTreeView.treeItems;
          this.selectedLocations = validatedTreeView.selectedItems;
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    saveResourceCalendar() {
      this.isLoading = true;

      let selectedLocationIds = GetOptionIdsForOptionPaths(
        this.locationOptions[0].children,
        this.selectedLocations,
      );

      const locationTree = CreateTreeViewObject(
        this.locationOptions[0].children,
        selectedLocationIds,
        this.editionId,
        this.holidayType,
      );

      let newResourceCalendar = {
        id: this.resourceCalendarToEdit.id,
        date: new Date(this.date),
        configurationId: this.editionId,
        publicHolidayType: this.holidayType,
        forCH: false,
        ressourceCalendarContents: [
          {
            id: this.holidayNameDE.id,
            ressourceCalendarId: this.resourceCalendarToEdit.id,
            holidayDescription: this.holidayNameDE.description,
            language: "de-CH",
          },
          {
            id: this.holidayNameFR.id,
            ressourceCalendarId: this.resourceCalendarToEdit.id,
            holidayDescription: this.holidayNameFR.description,
            language: "fr-CH",
          },
          {
            id: this.holidayNameIT.id,
            ressourceCalendarId: this.resourceCalendarToEdit.id,
            holidayDescription: this.holidayNameIT.description,
            language: "it-CH",
          },
        ],
        locationTree: locationTree,
      };

      UpdateRessourceCalendar(
        this.resourceCalendarToEdit.id,
        newResourceCalendar,
        () => {
          this.clearInputs();
          this.$emit("saved");
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    clearInputs() {
      this.errorObject = "";
      this.holidayNameDE = { id: 0, description: "", language: "de-CH" };
      this.holidayNameFR = { id: 0, description: "", language: "fr-CH" };
      this.holidayNameIT = { id: 0, description: "", language: "it-CH" };
      this.date = null;
      this.holidayType = 1;
      this.selectedLocations = [];
    },
    cancel() {
      this.clearInputs();
      this.$emit("canceled");
    },
  },
};
</script>
<style scoped></style>
